import {
  Component,
  effect,
  inject,
  input,
  output,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ReservaApiService } from '@core/services/api/reserva-api.service';
import {
  IReservaHorarioData,
  IReservaRecursoData,
} from '@core/interfaces/entidades/reserva.entidad';
import { ToastService } from '@shared/services/toast.service';
import { DIAS_SEMANA_LABELS } from '@core/enums/reserva.enum';
import { SucursalService } from '@shared/services/sucursal.service';
import { AppService } from '@shared/services/app.service';
import { UiButton } from '@shared/components/ui';
import { FormsModule } from '@angular/forms';

interface HorarioEditItem {
  dia_semana: number;
  hora_inicio: string;
  hora_fin: string;
  activo: boolean;
}

@Component({
  selector: 'app-config-horarios',
  imports: [UiButton, FormsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './config-horarios.html',
})
export class ConfigHorarios {
  private api = inject(ReservaApiService);
  private toast = inject(ToastService);
  private sucursalService = inject(SucursalService);
  private appService = inject(AppService);

  constructor() {
    effect(() => {
      if (this.sucursalService.sucursalReady() && this.appService.authReady()) {
        this.cargarHorarios();
      }
    });
  }

  readonly recurso = input.required<IReservaRecursoData>();
  readonly cerrar = output<void>();

  daysOfWeek = [0, 1, 2, 3, 4, 5, 6];
  dayLabels = DIAS_SEMANA_LABELS;
  horariosEdit = signal<HorarioEditItem[]>([]);

  cargarHorarios() {
    this.api.listarHorarios(this.recurso().id).subscribe({
      next: (data: IReservaHorarioData[]) => {
        this.horariosEdit.set(
          this.daysOfWeek.map((dia) => {
            const existente = data.find((h) => h.dia_semana === dia);
            return {
              dia_semana: dia,
              hora_inicio: existente?.hora_inicio ?? '09:00',
              hora_fin: existente?.hora_fin ?? '18:00',
              activo: !!existente,
            };
          }),
        );
      },
    });
  }

  onCerrar() {
    this.cerrar.emit();
  }

  guardar() {
    const activos = this.horariosEdit()
      .filter((h) => h.activo)
      .map((h) => ({
        dia_semana: h.dia_semana,
        hora_inicio: h.hora_inicio,
        hora_fin: h.hora_fin,
      }));
    this.api.reemplazarHorarios(this.recurso().id, activos).subscribe({
      next: () => {
        this.toast.show('top-right', 'success', 'Éxito', 'Horarios actualizados');
        this.cerrar.emit();
      },
      error: (err) => {
        if (err.status === 401) return;
        this.toast.show('top-right', 'error', 'Error', 'No se pudieron guardar los horarios');
      },
    });
  }
}
